<template>
  <!-- 普通用户 -->
  <div class="card-box" v-if="item.userType === 0 && item.userId !== userId">
    <div class="dialog-time">{{item.createTime}}</div>
    <div class="card-main item-left">
      <div class="card-image">
        <img :src="tx_1" alt />
      </div>
      <div class="card-content">
        <div class="nick-name">
          <p>用户{{item.userId}}</p>
        </div>
        <div v-if="item.imgMsg !== 1" class="message">
          <p v-html="item.message"></p>
        </div>
        <el-image class="card-img" v-if="item.imgMsg === 1" :src="item.message" alt="" :preview-src-list="[item.message]"></el-image>
      </div>
    </div>
  </div>
  <!-- 当前用户 -->
  <div class="card-box" v-else-if="item.userType === 0 && item.userId === userId">
    <div class="dialog-time">{{item.createTime}}</div>
    <div class="card-main item-right" >
      <div class="card-image">
        <img :src="tx_2" alt />
      </div>
      <div class="card-content" :class="[sourceCode === 'aisino' ? 'aisino-card-content' : '']">
        <div class="nick-name">
          <p>我</p>
        </div>
        <div v-if="item.imgMsg !== 1" class="message">
          <p v-html="item.message"></p>
        </div>
        <el-image class="card-img" v-if="item.imgMsg === 1" :src="item.message" alt="" :preview-src-list="[item.message]"></el-image>
      </div>
      <img v-if="item.errSend === true" src="http://zsdy-data-center.oss-cn-huhehaote.aliyuncs.com/data-admin/15967822259571085825235472378514.png" alt="" class="erricon" @click="cxsend(item)">
    </div>
  </div>
  <!-- 客服用户 -->
  <div class="card-box" v-else-if="item.userType === 1">
    <div class="dialog-time">{{item.createTime}}</div>
    <div class="card-main">
      <div class="card-image">
        <img :src="timg" alt />
      </div>
      <div class="card-content">
        <div class="nick-name">
          <div class="operators">专家助手</div>
          <p>{{item.operateName}}</p>
        </div>
        <div class="message">
          <div class="question-content" v-if="item.messageType === 1">
            <div v-if="userId === item.replyUserId" class="questioner"><p>回复我：</p></div> 
            <div v-else class="questioner"><p>回复用户{{item.replyUserId}}：</p></div> 
            <div class="question">
              <p v-if="item.answerImgMsg !== 1" v-html="item.question"></p>
              <el-image class="reply-img" v-if="item.answerImgMsg === 1" :src="item.question" alt="" :preview-src-list="[item.question]"></el-image>
            </div>
          </div>
          <div class="reply-content" v-if="item.messageType === 1">
            <p v-if="item.imgMsg !== 1" v-html="'专家组回复：' + item.message"></p>
            <el-image class="reply-img" v-if="item.imgMsg === 1" :src="item.message" alt="" :preview-src-list="[item.message]"></el-image>
          </div>
          <div v-else>
            <div v-if="item.imgMsg !== 1" class="reply-content">
              <p v-if="item.imgMsg !== 1" v-html="item.message"></p>
            </div>
            <el-image class="reply-img" v-if="item.imgMsg === 1" :src="item.message" alt="" :preview-src-list="[item.message]"></el-image>
          </div>
          <!--liyanze分支增加 收藏部分-->
					<div class="shoucangBox" v-if="!isCJT&&item.messageType === 1">
						<div class="shoucangImgBox" v-if="thatIsSc==0"
							@click="choucangSBW(item.answerImgMsg,item.question,item.imgMsg,item.message,item.id,index)">
							<img :src="sbwpcSC" alt="">
							<div class="shoucangTextBox">收藏</div>
						</div>
						<div class="shoucangImgBox" v-if="thatIsSc==1">
							<img :src="sbwpcYSC" alt="">
							<div class="shoucangTextBox">已收藏</div>
						</div>
					</div>
          <div class="solve-box" v-if="userId === item.replyUserId && item.solve !== 0">
              <div class="solve-btn">
                <div class="solved solve-item" :class="[SOLVED(item, index, 1) ? 'active': '' ]" @click.stop="solve(item, 1, index)">
                  <p>已解决</p>
                  <img :src="icon_2" alt="">
                </div>
                <div class="unsolved solve-item" :class="[SOLVED(item, index, 3) ? 'active': '' ]" @click.stop="solve(item, 3, index)">
                  <p>未解决</p>
                  <img :src="icon_1" alt="">
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tx_1 from "@/assets/tx1.png";
import tx_2 from "@/assets/tx2.png";
import tx_3 from "@/assets/tx3.png";
import timg from "@/assets/timg.jpg";
import icon_1 from "@/assets/icon_1.png";
import icon_2 from "@/assets/icon_2.png";
import { CHAT_API_DATA } from '@/api/chat';

import sbwpcYSC from "@/assets/sbwpcYSC.png";
import sbwpcSC from "@/assets/sbwpcSC.png";

import { API_DATA } from "@/api/index";

export default {
  name: "chatCard",
  props: ['item', 'index'],
  data() {
    return {
      tx_1,
      tx_2,
      tx_3,
      timg,
      icon_1,
      icon_2,
      sbwpcYSC,
      sbwpcSC,
      userId:'',
      sourceCode: '',
      solved: {},
      //是否收藏
      thatIsSc:0,
      //是否为畅捷通
      isCJT:false,
    };
  },
  computed: {
    SOLVED () {
      return function (item, index, val) {
        let bool = Object.keys(this.solved).find(n => n === String(index))
        if(bool) {
          return item.solve === val || this.solved[index].solve === val
        } else {
          return item.solve === val 
        }
      }
      
    },
  },
  created(){
    //debugger
    //判断是否为 航信通
    let thatQuery = this.$route.query.sourceCode;
    if(thatQuery == 'aisino'){
      this.isCJT = true;
    }else{
     // this.isCJT = false;
    }
    //判断是否为 畅捷通(测试)
    let thatQueryGG_daily = this.$route.query.sourceCode;
    if(thatQueryGG_daily == 'chanjetDefault'){
      this.isCJT = true;
    }else{
      //this.isCJT = false;
    }
    //判断是否为 畅捷通(正式)
    let thatQueryGG = this.$route.query.sourceCode;
    if(thatQueryGG == 'cdsyqy'){
      this.isCJT = true;
    }else{
      //this.isCJT = false;
    }
    
    let nowStatus = this.item.isCollection
    if(nowStatus==undefined){
      
    }else{
      this.thatIsSc = this.item.isCollection
    }
    //this.thatIsSc = this.item.isCollection
  },
  mounted() {
    this.userId = parseInt(JSON.parse(localStorage.getItem('userInfo')).id)
    this.sourceCode = this.$route.query.sourceCode
  },
  methods: {
    cxsend(item) {
      this.$emit('cxsend', item)
    },
    //liyanze分支增加收藏问答接口
    choucangSBW(userMsgType,userMsg,teacherMsgType,teacherMsg,dataId,index){
      let data = {
        answerType:teacherMsgType,
        questionType:userMsgType,
        answer:teacherMsg,
        question:userMsg,
        messageId:dataId,
      };
      let url = 'collections/save'
      API_DATA.doPostDataSBW(data,url).then(res => {
        this.thatIsSc = 1
      })

      
    },
    // 客户评价
    solve(item, val, i) {
      let bool = !Object.keys(this.solved).find(n => n === String(i))
      let data = {
        id: item.id,
        solve: val
      }
      if(item.solve === 2 && bool) {
        CHAT_API_DATA.solve(data).then((res) => {
          this.solved = {
              [i]:{
                id: item.id,
                solve: val
              },
              ...this.solved
            }
          console.log(res)
        })
      }
    }
  }
};
</script>   

<style scoped>
.card-box {
  margin-bottom: 30px;
  padding: 0 15px;
}
.card-box img {
  width: 50px;
  height: 50px;
}
.card-main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.nick-name{
  display: flex;
  margin: 0 0 20px 10px;
  font-size: 14px;
  color: #888888;
  align-items: center;
}
.message{
  max-width: 728px;
  font-size: 16px;
  background-color: #ffffff;
  color: #222222;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #d7dadd;
  word-break: break-all;
  word-wrap:break-word;
}
.dialog-time{
  width: 100%;
  text-align: center;
  color: #cccccc;
}
.card-main.item-left{
  flex-direction: row;
}
.card-main.item-left .message{
  background-color: #e5eefa;
  border:none;
}
.card-main.item-left .nick-name{
  margin: 0 0 20px 10px;
  text-align: left;
}
.card-main.item-right{
  flex-direction: row-reverse;
  align-content: center;
}
.card-main.item-right .message{
  border:none;
  background-color: #faeff0;
}
.card-main.item-right .nick-name{
  margin: 0 10px 20px 0;
  justify-content: flex-end;
}
.operators{
  display: inline-block;
  line-height: 30px;
  background-color: #2270E6;
  color: #ffffff;
  border-radius: 12px;
  padding: 0 10px;
  margin-right: 10px;
}
.question-content{
  color: #777777;
  font-size: 16px;
  width: 100%;
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
}
.reply-content{
  color: #2270E6;
  line-height: 30px;
  /* padding-top: 15px; */
}
img.erricon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  float: right;
  margin-top: 32px;
}
.card-box .card-img {
  width: 200px;
  height: 120px;
}
.card-box .reply-img {
  margin-top: 10px;
  width: 110px;
  height: 66px;
}
.solve-box {
  display: grid;
	grid-template-rows: auto auto;
  width: 100%;
  margin-top: 30px;
}
.solve-btn {
  text-align: center;
  height: 30px;
}
.solve-item {
  cursor: pointer;
  /* padding: 10px; */
  border-radius: 5px;
  font-size: 16px;
  width: 90px;
  height: 30px;
  margin-left: 16px;
  float: right;
  line-height: 30px;
  font-family: 'Source Han Sans CN';
}
.solve-item img{
  width: 10px;
  height: 10px;
  float: left;
  margin-top: 10px;
  padding-left: 10px;
}
.solve-item p {
  display: inline;
}
.solved {
  border: 1px solid #48931b;
  color: #48931b;
}
.unsolved {
  border: 1px solid #d7555b;
  color: #d7555b;
}
.solved.active {
  background-color: #48931a;
  color: #ffffff;
}
.unsolved.active {
  background-color: #d7555b;
  color: #ffffff;
}
.unsolved.active img ,.solved.active img{
  filter: grayscale(100%) brightness(2000%);
}
 /deep/ .el-image-viewer__close {
  color: #000;
}

/* 定制版CSS */
.aisino-card-content {
  width: 80%;
}
.item-right .aisino-card-content .message{
  float: right;
}
.item-left .aisino-card-content .message{
  float: left;
}

/**liyanze分支增加 收藏按钮*/
	.shoucangBox{
		height:25px;
		margin-top:16px;
    cursor: pointer;
	}
	.shoucangImgBox{
		width:90px;
		font-size:16px;
		color:#777777;
		float: right;
	}
	.shoucangImgBox img{
		width:16px;
		height:16px;
		margin-right:10px;
    margin-top:3px;
    float: left;
	}
  .shoucangTextBox{
    float: left;
  }
</style>